import { Validator } from './validator';

export class AddressValidator implements Validator {
  public valid: boolean;
  public resolveValidationStrategy: () => Validator[];
  public readonly element: any;

  public constructor(
    resolveValidationStrategy: () => Validator[], element: any) {
    this.element = element;
    this.resolveValidationStrategy = resolveValidationStrategy;
  }

  public validate(): boolean {
    this.valid = this.isValid();
    return this.valid;
  }

  public isValid(): boolean {
    const validators = this.resolveValidationStrategy();

    const valid = validators?.reduce<boolean>((valid: boolean, validator: Validator) => { return validator.validate() && !!valid; }, true);

    return valid;
  }

  public sniff(): boolean {
    return this.isValid();
  }
}

